import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateManufacturerArg, UpdateManufacturerResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdateManufacturer = (): UseMutationResult<
  UpdateManufacturerResult,
  unknown,
  UpdateManufacturerArg
> => {
  const queryClient = useQueryClient();
  const { manufacturersApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationFn: async (arg: UpdateManufacturerArg) => await manufacturersApiClient.update(arg),
    mutationKey: MUTATION_KEYS.manufacturers.updateOne(),
    onError: error => {
      notify.error({
        message: 'There was an error while updating manufacturer',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.manufacturers.all());
      notify.success({
        message: 'Manufacturer updated',
      });
    },
  });
};
